import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { omit, isEmpty } from 'lodash'
import { API } from 'src/store/api'
import { getStore, setStore } from 'src/utils/auth'

// 获取诊所列表
export const getTestCenterList = createAsyncThunk(
  'testCenter/getTestCenterList',
  async (params, thunkAPI) => {
    const response = await API.getTestCenterList(params)
    return response.data
  },
)
// 获取所有医生列表
export const getDoctorList = createAsyncThunk('testCenter/getDoctorList', async (params, thunkAPI) => {
  const response = await API.getDoctorList(params)
  return response.data
})

// 获取诊所医生列表
export const getTestCenterInfo = createAsyncThunk(
  'testCenter/getTestCenterInfo',
  async (params, thunkAPI) => {
    const response = await API.getTestCenterInfo(params)
    return response.data
  },
)

// 获取可选医生列表
export const getAllTime = createAsyncThunk('testCenters/getAllTime', async (params, thunkAPI) => {
  const response = await API.getAllTime(params)
  return response.data
})
// 获取可选号源时间段
export const getClinicDoctorList = createAsyncThunk('testCenters/doctorList', async (params, thunkAPI) => {
  const response = await API.getClinicDoctorList(params)
  return response.data
})
// 获取医生详情
export const getDoctorInfo = createAsyncThunk('testCenter/getDoctorInfo', async (params, thunkAPI) => {
  const response = await API.getDoctorInfo(params)
  return response.data
})

export const testCenterSlice = createSlice({
  name: 'testCenter',
  initialState: {
    testCenterList: [],
    testCenterListStatus: '',
    selectedDoctor: getStore('selectedDoctor') || null,
    doctorList: [],
    doctorInfo: null,
    doctorInfoStatus: '',
    testCenterInfoStatus: '',
    allDoctorList: [],
    allDoctorListStatus: '',
    currentTestCenter: null,
  },
  reducers: {
    setSelectedDoctor(state, action) {
      state.selectedDoctor = action.payload || null
      setStore('selectedDoctor', action.payload)
    },
  },
  // reducers 支持两种不同的形式
  // 1、builder callback 适用于ts版本
  // 2、map object
  extraReducers: (builder) => {
    // 获取诊所列表
    builder.addCase(getTestCenterList.pending, (state, action) => {
      state.testCenterListStatus = 'pending'
    })
    builder.addCase(getTestCenterList.fulfilled, (state, action) => {
      state.testCenterListStatus = 'fulfilled'
      if (!action.payload) return
      state.testCenterList = action.payload?.filter((item) => item.status)
    })
    builder.addCase(getTestCenterList.rejected, (state, action) => {
      state.testCenterListStatus = 'rejected'
    })
    // 获取所有医生列表
    builder.addCase(getDoctorList.pending, (state, action) => {
      state.allDoctorListStatus = 'pending'
    })
    builder.addCase(getDoctorList.fulfilled, (state, action) => {
      state.allDoctorListStatus = 'fulfilled'
      if (!action.payload) return
      state.allDoctorList =
        action.payload
          ?.map((doctor) => {
            const { availableTimeList, testCenterName } = doctor
            const avlClinicList = availableTimeList
              ?.map((item) => {
                const clinicItem = testCenterName?.find(
                  (clinic) => clinic.id === item.testCenterId && clinic.clinicType === 1 && clinic.status,
                )
                return {
                  ...clinicItem,
                }
              })
              ?.filter((item) => !isEmpty(item))
            return avlClinicList?.length && doctor.status ? doctor : null
          })
          ?.filter((doctor) => doctor) || []
    })
    builder.addCase(getDoctorList.rejected, (state, action) => {
      state.allDoctorListStatus = 'rejected'
    })
    // 获取诊所医生列表
    builder.addCase(getTestCenterInfo.pending, (state, action) => {
      state.currentTestCenter = null
      state.testCenterInfoStatus = 'pending'
    })
    builder.addCase(getTestCenterInfo.fulfilled, (state, action) => {
      state.testCenterInfoStatus = 'fulfilled'
      if (!action.payload) return
      state.doctorList = action.payload?.doctorList?.filter((item) => item.status)
      state.currentTestCenter = action.payload?.status ? omit(action.payload, 'doctorList') : null
    })
    builder.addCase(getTestCenterInfo.rejected, (state, action) => {
      state.testCenterInfoStatus = 'rejected'
    })

    // 获取可选择医生列表
    builder.addCase(getClinicDoctorList.pending, (state, action) => {
      state.getClinicDoctorListStatus = 'pending'
    })
    builder.addCase(getClinicDoctorList.fulfilled, (state, action) => {
      if (!action.payload) return
      state.clinicDoctorList = action.payload
      state.getClinicDoctorListStatus = 'fulfilled'
    })
    builder.addCase(getClinicDoctorList.rejected, (state, action) => {
      state.getClinicDoctorListStatus = 'rejected'
    })

    // 获取可选择医生列表
    builder.addCase(getAllTime.pending, (state, action) => {
      state.getAllTimeStatus = 'pending'
    })
    builder.addCase(getAllTime.fulfilled, (state, action) => {
      if (!action.payload) return
      state.getAllTimeStatus = 'fulfilled'
      state.allTime = action.payload
    })
    builder.addCase(getAllTime.rejected, (state, action) => {
      state.getAllTimeStatus = 'rejected'
    })

    // 获取医生详情
    builder.addCase(getDoctorInfo.pending, (state, action) => {
      state.currentTestCenter = null
      state.doctorInfoStatus = 'pending'
    })
    builder.addCase(getDoctorInfo.fulfilled, (state, action) => {
      state.doctorInfoStatus = 'fulfilled'
      if (!action.payload) return
      state.doctorInfo = action.payload?.status ? action.payload : null
    })
    builder.addCase(getDoctorInfo.rejected, (state, action) => {
      state.doctorInfoStatus = 'rejected'
    })
  },
})

// Action creators are generated for each case reducer function
export const { setSelectedDoctor } = testCenterSlice.actions
export default testCenterSlice.reducer
